
<iframe [style.height]="innerHeight" id="DpiIframe" style="width: 100%;" [src]="dpiUrl | safe" title="Dpi"></iframe>
